import {
  faClock,
  faFileContract,
  faHeadSideHeadphones,
  faUsers
} from '@fortawesome/pro-light-svg-icons';
import { TFunction } from 'hooks/useI18n';
import ServiceEventTracking from 'services/service.event-tracking';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { NavItemTypes } from './Nav.types';

export const NAVITEMS = (
  t: TFunction,
  asPath: string,
  locale: string | undefined
): NavItemTypes[] => {
  return [
    {
      label: t('talent-engine-landing.nav.product'),
      isActive:
        asPath === getAppUrl(APP_URLS.talentEngineSave, locale) ||
        asPath === getAppUrl(APP_URLS.talentEngineCandidates, locale) ||
        asPath === getAppUrl(APP_URLS.talentEngineHiring, locale) ||
        asPath === getAppUrl(APP_URLS.talentEngineInterviews, locale),
      options: [
        {
          label: t('talent-engine-landing.nav.save'),
          value: 'save',
          icon: faClock,
          href: getAppUrl(APP_URLS.talentEngineSave, locale),
          activeClassCondition:
            asPath === getAppUrl(APP_URLS.talentEngineSave, locale),
          onClick: () =>
            ServiceEventTracking.trackLandingLinkClicked(
              'talent-engine-menu-sublanding-ahorra-tiempo'
            )
        },
        {
          label: t('talent-engine-landing.nav.candidates'),
          value: 'candidates',
          icon: faUsers,
          href: getAppUrl(APP_URLS.talentEngineCandidates, locale),
          activeClassCondition:
            asPath === getAppUrl(APP_URLS.talentEngineCandidates, locale),
          onClick: () =>
            ServiceEventTracking.trackLandingLinkClicked(
              'talent-engine-menu-sublanding-mejores-candidatos'
            )
        },
        {
          label: t('talent-engine-landing.nav.hiring'),
          value: 'hiring',
          icon: faFileContract,
          href: getAppUrl(APP_URLS.talentEngineHiring, locale),
          activeClassCondition:
            asPath === getAppUrl(APP_URLS.talentEngineHiring, locale),
          onClick: () =>
            ServiceEventTracking.trackLandingLinkClicked(
              'talent-engine-menu-sublanding-contrata-mas'
            )
        },
        {
          label: t('talent-engine-landing.nav.interviews'),
          value: 'interviews',
          icon: faHeadSideHeadphones,
          href: getAppUrl(APP_URLS.talentEngineInterviews, locale),
          activeClassCondition:
            asPath === getAppUrl(APP_URLS.talentEngineInterviews, locale),
          onClick: () =>
            ServiceEventTracking.trackLandingLinkClicked(
              'talent-engine-menu-sublanding-consigue-entrevistas'
            )
        }
      ]
    },
    {
      label: t('talent-engine-landing.nav.blog'),
      href: getAppUrl(APP_URLS.talentEngineBlog, locale),
      isActive: asPath === `${getAppUrl(APP_URLS.talentEngineBlog, locale)}`,
      serviceEvent: () => {
        ServiceEventTracking.trackLandingLinkClicked('talent-engine-menu-blog');
      }
    },

    {
      label: t('talent-engine-landing.nav.new'),
      href: getAppUrl(APP_URLS.talentEngineBlogWhatsNew, locale),
      isActive:
        asPath === `${getAppUrl(APP_URLS.talentEngineBlogWhatsNew, locale)}`,
      serviceEvent: () => {
        ServiceEventTracking.trackLandingLinkClicked(
          'talent-engine-menu-whats-new'
        );
      }
    }
  ];
};
